
import SearchBar from "./SearchBar";
import { useCallback } from "react";
import Particles from "react-tsparticles";
import { Engine } from "tsparticles-engine";
import { loadFull } from "tsparticles";
import { motion } from "framer-motion";
import { Card } from "./ui/card";

const Hero = () => {
  const particlesInit = useCallback(async (engine: Engine) => {
    await loadFull(engine);
  }, []);

  const handleSolutionsRedirect = () => {
    window.location.href = 'https://ragnarai.netlify.app/';
  };

  const handleSalesRedirect = () => {
    window.location.href = 'https://agera.solutions/';
  };

  return (
    <div className="relative min-h-screen flex flex-col bg-gradient-to-br from-[#1A1F2C] via-[#6E59A5] to-[#9b87f5]">
      <div className="relative flex-1 flex flex-col min-h-screen">
        <Particles
          id="tsparticles"
          init={particlesInit}
          options={{
            particles: {
              number: { value: 80, density: { enable: true, value_area: 800 } },
              color: { value: "#D6BCFA" },
              shape: { type: "circle" },
              opacity: {
                value: 0.5,
                random: true,
                anim: {
                  enable: true,
                  speed: 1,
                  opacity_min: 0.1,
                  sync: false
                }
              },
              size: {
                value: 3,
                random: true,
                anim: {
                  enable: true,
                  speed: 2,
                  size_min: 0.1,
                  sync: false
                }
              },
              line_linked: {
                enable: true,
                distance: 150,
                color: "#E5DEFF",
                opacity: 0.4,
                width: 1
              },
              move: {
                enable: true,
                speed: 2,
                direction: "none",
                random: false,
                straight: false,
                out_mode: "out",
                bounce: false,
                attract: { enable: false, rotateX: 600, rotateY: 1200 }
              }
            },
            interactivity: {
              detect_on: "window",
              events: {
                onhover: { enable: true, mode: "repulse" },
                onclick: { enable: true, mode: "push" },
                resize: true
              }
            },
            retina_detect: true,
            background: { color: "transparent" }
          }}
        />
        
        {/* Radial Gradient Overlay */}
        <div 
          className="absolute inset-0 pointer-events-none" 
          style={{
            background: 'radial-gradient(circle at 50% 50%, rgba(214,188,250,0.1) 0%, rgba(26,31,44,0.2) 100%)',
          }} 
        />
        
        {/* Main content container */}
        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center justify-start space-y-16 pt-44">
          {/* Interactive Panels */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 w-full max-w-5xl mx-auto"
          >
            <motion.div
              whileHover={{ scale: 1.02, translateY: -5 }}
              transition={{ duration: 0.2 }}
              className="cursor-pointer"
              onClick={handleSolutionsRedirect}
            >
              <Card className="group relative overflow-hidden h-full min-h-[240px] bg-white/5 backdrop-blur-md border-white/20 transition-all duration-300 hover:shadow-[0_0_30px_rgba(214,188,250,0.3)]">
                <div className="absolute inset-0 bg-gradient-to-br from-purple-500/20 via-indigo-500/20 to-purple-600/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="relative h-full p-8 md:p-12 flex flex-col items-center justify-center">
                  <h2 className="text-4xl md:text-5xl font-display font-semibold text-white mb-6">Solutions</h2>
                  <p className="text-white/80 text-xl">Rule your industry</p>
                </div>
              </Card>
            </motion.div>

            <motion.div
              whileHover={{ scale: 1.02, translateY: -5 }}
              transition={{ duration: 0.2 }}
              className="cursor-pointer"
              onClick={handleSalesRedirect}
            >
              <Card className="group relative overflow-hidden h-full min-h-[240px] bg-white/5 backdrop-blur-md border-white/20 transition-all duration-300 hover:shadow-[0_0_30px_rgba(214,188,250,0.3)]">
                <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/20 via-purple-500/20 to-indigo-600/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <div className="relative h-full p-8 md:p-12 flex flex-col items-center justify-center">
                  <h2 className="text-4xl md:text-5xl font-display font-semibold text-white mb-6">Sales</h2>
                  <p className="text-white/80 text-xl">Dominate your market</p>
                </div>
              </Card>
            </motion.div>
          </motion.div>

          {/* AI Search Section */}
          <div className="w-full max-w-4xl mx-auto mt-24">
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-center mb-12"
            >
              <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-6">
                AI-Powered Business Intelligence
              </h2>
              <p className="text-lg md:text-xl text-white/80">
                Get instant, AI-driven insights for your business challenges
              </p>
            </motion.div>
            <SearchBar isAISearch={true} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
